"use strict";
/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormPageAuthenticationConditionDateBetweenOperator = void 0;
exports.FormPageAuthenticationConditionDateBetweenOperator = {
    Between: 'between',
    NotBetween: 'notBetween'
};
